var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "h1",
        [
          _c("svg-icon", { attrs: { "icon-class": "store-solid" } }),
          _vm._v(" " + _vm._s(_vm.$t("legalEntities")))
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.legalEntities },
                      on: { "row-click": _vm.handleRowClick }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "registration_name",
                          label: _vm.$t("name")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "hover-underline fc-blue",
                                    attrs: {
                                      to: {
                                        name: "legal-entity-detail",
                                        params: {
                                          id: scope.row.reference,
                                          participant: scope.row.participant
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(scope.row.registration_name) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }